import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import PartnerWithJadav from "./sections/PartnerWithJadav";
import RejoignezLAventure from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <PartnerWithJadav />
      <RejoignezLAventure />
    </div>;
}